export enum LectureEntityStatus {
    Committed,
    New,
    Changed,
    Deleted
}